export default __webpack_public_path__ + "static/media/flag-spa.9816c154.svg";